import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AttendaceService from "../../services/attendance.service";

export const getAttendence = createAsyncThunk(
  "addAttendence/getaddAttendance",
  async (payload, thunkAPI) => {
    try {
      const response = await AttendaceService.getAttendence (payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addAttendence = createAsyncThunk(
  "addAttendence/addaddAttendence",
  async (data, thunkAPI) => {
    try {
      const response = await AttendaceService.addAttendence(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);



const initialState = {
  loading: false,
  error: null,
  attendancelist: [],
  updateSuccess: false,
};

/* =================== Slice =================== */

const attendanceSlice = createSlice({
  name: "attendance",
  initialState,

  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ---------- Get diarynote ---------- */
      .addCase(getAttendence.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAttendence.fulfilled, (state, action) => {
        state.loading = false;
        state.attendancelist = action.payload?.data || [];
      })
      .addCase(getAttendence.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add diarynote ---------- */
      .addCase(addAttendence.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addAttendence.fulfilled, (state, action) => {
        state.loading = false;
        state.attendancelist.unshift(action.payload?.data);
      })
      .addCase(addAttendence.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export const { resetUpdateStatus } = attendanceSlice.actions;
export default attendanceSlice.reducer;
